<ng-template #inviteModal let-modal>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="modal-header">
      <h4
        class="modal-title"
        *ngIf="
          initialModel == null || initialModel.Roles == null || initialModel.Roles.length === 0;
          else elseBlock
        ">
        Invite User
      </h4>
      <ng-template #elseBlock>
        <h4 class="modal-title">Edit User</h4>
      </ng-template>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-12">
          <label for="name">Name</label>
          <input id="name" formControlName="Name" class="form-control" type="text" />
          <div *ngIf="f.Name.errors?.required" class="input-error">*Please enter a Name</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label for="email">Email Address</label>
          <input id="email" formControlName="Email" class="form-control" type="email" />
          <div *ngIf="f.Email.errors?.required" class="input-error">*Please enter an Email</div>
          <div *ngIf="f.Email.errors?.email" class="input-error">
            *Please enter a valid Email address
          </div>
          <div *ngIf="f.Email.errors?.blacklistedDomain" class="input-error">
            *{{ f.Email.errors?.blacklistedDomain }} is an invalid domain. Please enter a different
            email address.
          </div>
          <div *ngIf="invalidDomain != null" class="text-danger">*{{ invalidDomain }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>Permissions</label>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              formControlName="AccessLevel"
              id="accessLevelLimited"
              [value]="false" />
            <label class="form-check-label" for="accessLevelLimited"
              ><span class="new"></span> Limited Access</label
            >
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              formControlName="AccessLevel"
              id="accessLevelFull"
              [value]="true" />
            <label class="form-check-label" for="accessLevelFull"
              ><span class="new"></span> Full Access</label
            >
          </div>
        </div>
      </div>

      <div class="bg-grey pt-3 ps-3 border-secondary border-top-1 border-bottom-1">
        <lib-permissions-list
          formControlName="Permissions"
          *ngIf="!f.AccessLevel.value"
          [availableOptions]="permissions"></lib-permissions-list>
        <div
          class="row"
          *ngIf="(hasTimeclock | async) && isCsrPortal && companySwipeclockIdSynched">
          <div class="col-4 fw-bold">Connected Products</div>
          <div class="col-8">
            <div class="row">
              <div class="col-4">
                <lib-checkbox
                  formControlName="IncludeTimekeeping"
                  label="Timekeeping"
                  [id]="'chkTimekeeping'"></lib-checkbox>
              </div>
              <div class="col-8">
                <input
                  class="form-control-sm green-border bg-grey"
                  placeholder="Please enter user id"
                  *ngIf="form.get('IncludeTimekeeping').value"
                  formControlName="TimekeepingId" />
                <span *ngIf="invalidTimekeepingId" class="text-danger">User ID is invalid</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="form.errors?.missingPermissions">
        <div class="col-12">
          <div class="text-danger">*You must select at least one permission.</div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button (click)="modal.dismiss()" type="button" class="btn btn-secondary">Cancel</button>
      <button [disabled]="form.invalid" type="submit" class="btn btn-primary">
        {{ buttonText }}
      </button>
    </div>
  </form>
</ng-template>
